export default "__VITE_ASSET__CBTDFFbh__"